import { render, staticRenderFns } from "./InputPassengers.vue?vue&type=template&id=45f034f0&scoped=true"
import script from "./InputPassengers.vue?vue&type=script&lang=js"
export * from "./InputPassengers.vue?vue&type=script&lang=js"
import style0 from "./InputPassengers.vue?vue&type=style&index=0&id=45f034f0&prod&scoped=true&lang=less"
import style1 from "./InputPassengers.vue?vue&type=style&index=1&id=45f034f0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f034f0",
  null
  
)

export default component.exports